export default "__VITE_ASSET__18b2a458__"